import filterConstants from '../constants';

const sharedBoard = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.sharedBoard,
  properties: {
    [filterConstants.PROPERTY.text]: '',
    [filterConstants.PROPERTY.assignee]: '',
    [filterConstants.PROPERTY.status]: '',
    [filterConstants.PROPERTY.priority]: '',
    [filterConstants.PROPERTY.reporter]: '',
    [filterConstants.PROPERTY.rangeDate]: '',
    [filterConstants.PROPERTY.startDate]: '',
    [filterConstants.PROPERTY.endDate]: '',
    [filterConstants.PROPERTY.creationDate]: '',
    [filterConstants.PROPERTY.color]: '',
    [filterConstants.PROPERTY.overdue]: '',
  },
});

export default sharedBoard;
